import React from "react";
import { PageWrapperTwoColumn } from "@cs/components/src/PageWrapper";
import PageTitle from "@cs/components/src/PageTitle";
import JobList from "./JobList";
import { Route, Routes } from "react-router-dom";
import { JobViewParams } from "./JobView";
import Section from "@cs/components/src/Section";
import { useMutation } from "react-query";
import ApiService from "../../services/ApiService";
import Button from "@cs/components/src/Button";
import { Play } from "react-feather";

const JobListScreen = (props: {
  dlq?: boolean;
  error?: boolean;
  title?: string;
}) => {
  const { dlq, title, error } = props;

  const dlqRedriveMutation = useMutation({
    mutationFn: async () => {
      await ApiService.fetch("POST", `/api/script_execution/dlq/redrive`);
    },
  });

  return (
    <>
      <PageTitle
        title={title}
        error={
          dlq && dlqRedriveMutation.isError
            ? "Failed to start redrive"
            : undefined
        }
        success={
          dlq && dlqRedriveMutation.isSuccess ? "Redrive started" : undefined
        }
      >
        {dlq && (
          <Button
            icon={Play}
            label="Redrive"
            onClick={() => dlqRedriveMutation.mutate()}
            type="success"
            loading={dlqRedriveMutation.isLoading}
          />
        )}
      </PageTitle>
      <PageWrapperTwoColumn>
        <Section>
          <JobList showOrganization dlq={dlq} error={error} />
        </Section>
        <Routes>
          <Route
            path=":systemDomainId/:instanceId/:jobId"
            element={<JobViewParams />}
          />
        </Routes>
      </PageWrapperTwoColumn>
    </>
  );
};

export default JobListScreen;
